<script context="module">
</script>

<script>
    import {
        onMount,
        onDestroy,
        afterUpdate,
        createEventDispatcher,
    } from "svelte";

    import { SamuraiBet } from "./SamuraiBet";
    import { getActiveBet } from "../../../../scripts/stake-api";

    import {
        Statistic,
        initStatistic,
        Text
    } from "svantic";
    initStatistic();

    import { LastBet, BetSettingsLocal } from "../../../../stores";

    let bet;

    onMount(async () => {
        let activeBet = await getActiveBet("samurai");
        console.log(activeBet.data);

        if (activeBet.data) {
            bet = new SamuraiBet(activeBet.data);
            // bet = bet
        }
    });

    export const placeBet = async () => {
        let betConfig = {
            amount: $BetSettingsLocal.amount,
            currency: $BetSettingsLocal.currency
            
        };

        if (bet?.data?.active !== true) {
            try {
                bet = new SamuraiBet();

                let [err, res] = await bet.bet(betConfig);

                if (err) throw err;

                return (bet = bet);
            } catch (error) {
                console.log("[ERROR] Samurai placeBet");
                console.error(error);
            }
        }
        else{
            return bet
        }
    };
    export const next = async () => {
        if (bet?.data?.active === true) {
            try {
              
                let [err, res] = await bet.next();

                if (err) throw err;

                return (bet = bet);
            } catch (error) {
                console.log("[ERROR] Samurai next");
                console.error(error);
            }
        }
    };


    // onDestroy(unsubscribe)
    // $: console.log(bet)
</script>

<div class="display-container">
    <div class="flex-container">
        <div class="flex-item">
            <Statistic size="small" inverted>
                <Statistic.Value text={true}>
                    <Statistic.Label>
                        <Text class="small">Result:</Text>
                    </Statistic.Label>
                </Statistic.Value>
            </Statistic>
        </div>
    </div>
</div>

<style>
  
    .display-container {
        /* width: auto;*/
        margin: auto;
    }

    .flex-container {
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
    }

    .flex-item {
        flex: 0 0 20%;
        padding: 4px;
        margin: 8px;
        /*    width: var(--itemSize);*/
        /*    height: var(--itemSize);*/
        /*  outline: 1px solid #696969;*/
        /*  background-color: #ececec;*/
    }

</style>
